import React from 'react'
// import { useParams } from 'react-router-dom'
// import Loader from '../Components/Loader'
import MuiTable from '../Components/MuiTable'
// removed unused import
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';


function Standings(props){
    //const { id } = useParams()
    const [year, setYear] = React.useState('2025');
    const years = ['2025','2024','2023','2022','2021','2020'];
    const url = `https://supermegadynasty.com/${props.league}/draft/${year}/draft.json`

    const headCells = [
      {
        id: 'rank',
        numeric: true,
        disablePadding: false,
        label: 'Rank',
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Name',
      },
      {
        id: 'wins',
        numeric: true,
        disablePadding: false,
        label: 'Wins',
      },
      {
        id: 'losses',
        numeric: true,
        disablePadding: false,
        label: 'Losses',
      },
      {
        id: 'pf_points',
        numeric: true,
        disablePadding: false,
        label: 'PF',
      },
      {
        id: 'pa_points',
        numeric: true,
        disablePadding: false,
        label: 'PA',
      },
      {
        id: 'pp_points',
        numeric: true,
        disablePadding: false,
        label: 'MAX PF',
      },
      {
        id: 'eff',
        numeric: true,
        disablePadding: false,
        label: 'Efficiency%',
      },
      {
        id: 'pts_diff',
        numeric: true,
        disablePadding: false,
        label: 'Point Diff',
      },
      {
        id: 'gb',
        numeric: true,
        disablePadding: false,
        label: 'GB',
      },
      {
        id: 'pts_behind',
        numeric: true,
        disablePadding: false,
        label: 'Pts Behind',
      },
    ];

    const title = `${props.league} Standings`

    return (
    <>
      {/* <div>
        <h1 className="font-bold text-2xl">{title} </h1>
      </div> */}

      <div className="mb-2">
        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel id="standings-year">Year</InputLabel>
            <Select
              labelId="standings-year"
              id="standings-year"
              value={year}
              label="Year"
              onChange={(e) => setYear(String(e.target.value))}
            >
              {years.map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </div>

      <div className="md:flex flex-wrap">
        <MuiTable headCells={headCells} url={url} title={title} page={15}/>
      </div>
      <div>
        add weekly rankings chart
      </div>
      </>
    )
}

export default Standings
